import './App.css';

import SliderMessenger from './Components/SliderMessenger/SliderMessenger';
import Topo from './Components/Topo/Topo';
import Banner from './Components/Banner/Banner';
import Menu from './Components/Menu/Menu';
import Carrossel from './Components/Carrossel/Carrossel';
import CampanhaResidencial from './Components/Campanhas/CampanhaResidencial';
import CampanhaCorporativo from './Components/Campanhas/CampanhaCorporativo';
import CampanhaOQueFazemos from './Components/Campanhas/CampanhaOQueFazemos';
import Section from './Components/Sections/Section';
import PainelParalaxe1 from './Components/PaineisParalaxe/PainelParalaxe1';
import PainelParalaxe2 from './Components/PaineisParalaxe/PainelParalaxe2';
import PainelParalaxe3 from './Components/PaineisParalaxe/PainelParalaxe3';
import PainelParalaxe4 from './Components/PaineisParalaxe/PainelParalaxe4';
import Enumerator from './Components/Enumerator/Enumerator';
import QuemSomos from './Components/QuemSomos/QuemSomos';
import Footer from './Components/Footer/Footer';
import WhatsAppButton from './Components/WhatsAppButton/WhatsAppButton';
import CookieConsent from './Components/CookieConsent/CookieConsent';
import TermosDeUso from './Components/TermosDeUso/TermosDeUso';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <main>
        <BrowserRouter>
            <Routes>
              <Route path='/' element={
                <>
                  <SliderMessenger/>
                  <Topo/>
                  <Banner/>
                  <CampanhaOQueFazemos/>
                  <Carrossel/>
                  <CampanhaResidencial/>
                  <PainelParalaxe1/>
                  <CampanhaCorporativo/>
                  <PainelParalaxe2/>
                  <Section slogan="Planejados com cuidado e dedicação" />
                  <PainelParalaxe3/>
                  <Section slogan="Como os seus sonhos: sem limites!" />
                  <PainelParalaxe4/>
                  <Section slogan="Arce Desing: sua melhor decisão!" />
                  <Enumerator/>
                  <QuemSomos/>
                </>
              }/>
              <Route path='/politica-de-privacidade' element={
                <>
                  <TermosDeUso/>
                </>  
              }/>
              <Route path='*' element={
                <>
                <p> - </p>
                <p> - </p>
                <p> - </p>
                <h1>Error 404</h1>
                <h3>A página que você está procurando não existe - clique em VOLTAR no navegador</h3>
                </>
              }/>
            </Routes>
            <Footer/>
        </BrowserRouter>
      </main>
        <WhatsAppButton
          phoneNumber="5592981182887"// Substitua pelo número de telefone com o código do país (ex: 55 para Brasil, 21 para DDD)
          message="Olá! Visitei o site www.arcedesign.com.br e gostaria de mais informações sobre móveis planejados." // Mensagem pré-preenchida
        />
      <footer>
        <CookieConsent/>
      </footer>

    </div>

  );
}

export default App;